export const checkIsIOS = () => {
  const iOSPlatforms = ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'];
  const isIPhone = iOSPlatforms.includes(navigator.userAgent);
  const isIPad = (navigator.userAgent.includes('Mac') && 'ontouchend' in document);

  return isIPhone || isIPad;
};

export const checkIsInStandaloneMode = () => window.matchMedia('(display-mode: standalone)').matches;
